"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Nav_1 = require("./Nav");
const ApplicationStore_1 = require("../stores/ApplicationStore");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const fluxible_router_1 = require("fluxible-router");
const pages = require("../../backend/configs/routes");
const Footer_1 = require("./Footer");
const scripts = require("../scripts");
const clientDebug_1 = require("../clientDebug");
const react_1 = require("react");
const react_helmet_1 = require("react-helmet");
const $ = require("jquery");
const RouteStore_1 = require("../stores/RouteStore");
class Application extends React.Component {
    /*static contextTypes = {
        getStore: PropTypes.func.isRequired,
        executeAction: PropTypes.func.isRequired,
    };*/
    componentDidUpdate(prevProps, prevState) {
        const newProps = this.props;
        if (newProps.pageTitle === prevProps.pageTitle) {
            return;
        }
        document.title = newProps.pageTitle;
    }
    initLogging() {
        (0, clientDebug_1.trackEvent)('page open', { href: document.location.href });
        (0, clientDebug_1.initLoggingOnLoad)();
    }
    componentDidMount() {
        if (window.location.href.indexOf('wow') === -1) {
            this.initLogging();
        }
        scripts.setWindow(window.innerWidth, $(window).height());
        $(window).scroll(function () {
            scripts.headerSticky();
        });
        $(window).on('load resize', function () {
            scripts.comingsoon();
        });
        // scripts.PiNavigation();
        $(document).ready(function () {
            scripts.pageJs();
            scripts.piFooterWidgets();
            scripts.piIframeResponsive();
            scripts.piEmptySocialAndSharing();
            scripts.piEditSubmitButton();
            scripts.piEmptyComment();
            scripts.piEmptyPagination();
            if ($('.blog-1st, .blog-grid').find('.sidebar').length === 0) {
                $('.blog-1st, .blog-grid').addClass('no-sidebar');
            }
            if (scripts.isMobile.iOS()) {
                $('.blog-heading')
                    .addClass('fix-background-ios');
            }
        });
        $(window).ready(function () {
            scripts.piGridrotator();
            // scripts.pageSlider();
            scripts.grid();
            scripts.piPlaceholder();
            $('.author-thumb').imageCover();
            $('.image-cover').imageCover();
            $('.widget_slider .image-wrap').imageCover();
            $('.blog-list .post .image-wrap').imageCover();
            scripts.Pimasonry();
        });
    }
    render() {
        const Handler = this.props.currentRoute != null ? this.props.currentRoute.handler : react_1.Fragment;
        const title = this.props.title;
        return (React.createElement("div", null,
            React.createElement("header", { id: 'header', className: 'header' },
                React.createElement("div", { className: 'header-inner' },
                    React.createElement("div", { className: 'container' },
                        React.createElement("div", { className: 'logo' },
                            React.createElement(fluxible_router_1.NavLink, { href: '/' },
                                React.createElement("img", { src: this.props.logo, alt: 'logo' }))),
                        React.createElement(Nav_1.default, { currentRoute: this.props.currentRoute, links: pages.default, executeAction: this.props.executeAction })))),
            React.createElement(react_helmet_1.Helmet, null,
                React.createElement("title", null, title),
                this.props.imageUrl ? React.createElement("meta", { name: 'twitter:card', content: 'summary_large_image' }) :
                    React.createElement("meta", { name: 'twitter:card', content: 'summary' }),
                this.props.imageUrl && React.createElement("meta", { name: 'og:image', content: this.props.imageUrl }),
                React.createElement("meta", { property: 'og:url', content: this.props.host + this.props.path }),
                React.createElement("meta", { property: 'og:title', content: title }),
                React.createElement("meta", { property: 'og:site_name', content: this.props.siteTitle }),
                React.createElement("meta", { property: 'og:description', content: this.props.description }),
                React.createElement("meta", { property: 'description', content: this.props.description }),
                this.props.twitterName && React.createElement("meta", { name: 'twitter:site', content: this.props.twitterName }),
                this.props.twitterName && React.createElement("meta", { name: 'twitter:creator', content: this.props.twitterName })),
            React.createElement(Handler, null),
            React.createElement(Footer_1.default, null)));
    }
}
exports.default = (0, fluxible_addons_react_1.provideContext)((0, fluxible_router_1.handleHistory)((0, fluxible_addons_react_1.connectToStores)(Application, [ApplicationStore_1.default], (context, props) => {
    var _a;
    const appStore = context.getStore(ApplicationStore_1.default);
    const siteTitle = context.getStore(ApplicationStore_1.default).getParam('site_title') || 'xbimz.world';
    const title = format(context.getStore(RouteStore_1.default).getCurrentNavigate().route.title, [siteTitle]);
    return {
        siteTitle,
        title,
        description: context.getStore(ApplicationStore_1.default).getParam('site_description') || '',
        imageUrl: context.getStore(ApplicationStore_1.default).getParam('logo_url'),
        twitterName: (_a = context.getStore(ApplicationStore_1.default).getParam('twitter_name')) !== null && _a !== void 0 ? _a : 'Xbim_dev',
        host: context.getStore(ApplicationStore_1.default).getParam('host'),
        path: context.getStore(ApplicationStore_1.default).getPath(),
        logo: appStore.getParam('logo_url'),
    };
})));
function format(text, args) {
    if (!text) {
        return '';
    }
    return text.replace(/{(\d+)}/g, (match, num) => {
        return typeof args[num] !== 'undefined'
            ? args[num]
            : match;
    });
}
